export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10616.cc811c99.jpg";